import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import { RegisteredIconContext } from './IconRegistry';
import './icon.css';

import { ReactComponent as googleCalendar } from '../../assets/color-icons/GoogleCalendar.js';
import { ReactComponent as outlook } from '../../assets/color-icons/Outlook.js';
import { ReactComponent as americanExpress } from '../../assets/color-icons/AmericanExpress.js';
import { ReactComponent as dinersClub } from '../../assets/color-icons/DinersClub.js';
import { ReactComponent as discover } from '../../assets/color-icons/Discover.js';
import { ReactComponent as jcb } from '../../assets/color-icons/JCB.js';
import { ReactComponent as visa } from '../../assets/color-icons/Visa.js';
import { ReactComponent as masterCard } from '../../assets/color-icons/MasterCard.js';
import { IconsMap } from './Icon';

export const defaultColorIcons = {
  googleCalendar,
  outlook,
  americanExpress,
  dinersClub,
  discover,
  masterCard,
  jcb,
  visa
};

export type DefaultColorIconNames = keyof typeof defaultColorIcons;

export interface ColorIconProps {
  className?: string;
  name: DefaultColorIconNames | string;
  viewBox?: string;
}

export const ColorIcon: FC<ColorIconProps> = ({ className, name, viewBox = '0 0 24 24', ...props }) => {
  const registeredIcons = useContext(RegisteredIconContext);

  const icons: IconsMap = {
    ...defaultColorIcons,
    ...registeredIcons
  };

  if (!name) {
    throw new Error(`You must provide a valid "name" prop to the "Icon" component.`);
  }

  if (!icons[name]) {
    throw new Error(`Color Icon with name "${name}" does not exist.`);
  }

  const IconSvg = icons[name];

  return (
    <span className={classNames('lc-icon', `lc-icon-color`, `lc-icon-${name}`, className)} {...props}>
      <IconSvg viewBox={viewBox} />
    </span>
  );
};
